<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <i class="fa fa-chevron-left" v-if="displayReps != true" @click="showDisplayReps()"></i>
        <h6 class="modal-title">{{ modalTitle }}</h6>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="goal-content">
          <p class="font-weight-bold">Task:</p>
          <p class="task_name">{{ getTaskName() }}</p>
        </div>

        <div class="otherTaskRating" v-if="helpRating">
          <div class="col-7 p-0 float-left font-weight-bold" style>
            Did the work on this help you become more professional?
          </div>
          <div class="col-5 float-left" style="text-align: center;" v-if="helpRating == 1">
            <p class="task_name" style="margin: 0">
              <img src="@/assets/no.gif" width="50" heiht="50" />
            </p>
            <p class="task_name" style="margin: 0">
              No!
            </p>
          </div>
          <div class="col-5 float-left" style="text-align: center;" v-else-if="helpRating == 2">
            <p class="task_name" style="margin: 0">
              <img src="@/assets/mild_no.gif" width="50" heiht="50" />
            </p>
            <p class="task_name" style="margin: 0">
              Mild No
            </p>
          </div>
          <div class="col-5 float-left" style="text-align: center;" v-else-if="helpRating == 3">
            <p class="task_name" style="margin: 0">
              <img src="@/assets/maybe.gif" width="50" heiht="50" />
            </p>
            <p class="task_name" style="margin: 0">
              Maybe
            </p>
          </div>
          <div class="col-5 float-left" style="text-align: center;" v-else-if="helpRating == 4">
            <p class="task_name" style="margin: 0">
              <img src="@/assets/mild_yes.gif" width="50" heiht="50" />
            </p>
            <p class="task_name" style="margin: 0">
              Mild Yes
            </p>
          </div>
          <div class="col-5 float-left" style="text-align: center;" v-else-if="helpRating == 5">
            <p class="task_name" style="margin: 0">
              <img src="@/assets/yes.gif" width="50" heiht="50" />
            </p>
            <p class="task_name" style="margin: 0">
              Yes!
            </p>
          </div>
          <div style="clear: both;"></div>
        </div>

        <div class="goal-form" v-if="displayReps">
          <div v-show="submit_form_errors" class="validate-warning-msg-login">{{ submit_form_errors }}</div>
          
            <div class="form-group row">
              <label class="col-12 col-sm-4 col-md-4 col-lg-5 col-xl-5 goal_label">Time spent on task:<span class="required">*</span></label>
              <div class="col-12 col-sm-8 col-md-8 col-lg-7 col-xl-7">
                <date-picker 
                  name="Time spent on task"
                  v-model="display_time" 
                  v-validate="'required'"
                  type="time" 
                  placeholder="Hours:Minutes"
                  :popup-style="timePickerStyle"
                  format="HH:mm"
                  @change="inputHandler"
                  v-bind:clearable="false"
                  v-bind:editable="false"
                  ref="timepicker">
                </date-picker>
                <div v-if="verrors.firstByRule('Time spent on task', 'required')" :class="'validate-warning-msg '  + vmessage">Time spent on task is required</div>
              </div>
            </div>
            <div class="form-group row" v-if="subTaskId != 99999">
              <label class="col-12 col-sm-4 col-md-4 col-lg-5 col-xl-5 goal_label">Rate This Repetition:<span class="required">*</span></label>
              <div class="col-12 col-sm-8 col-md-8 col-lg-7 col-xl-7">
                <select 
                    name="Rate This Repetition"
                    v-validate="'required'" 
                    v-model="score" 
                    class="form-control">
                    <option value="">Select Rating</option>
                    <option v-for="(item, index) in items_options" :key="index" :value="item.value">{{ item.display }}</option>
                </select>
                <div v-if="verrors.firstByRule('Rate This Repetition', 'required')" :class="'validate-warning-msg ' + vmessage">Rate This Repetition is required</div>
              </div>
            </div>
            <div class="form-group row" v-if="subTaskId != 99999">
              <label class="col-12 col-sm-4 col-md-4 col-lg-5 col-xl-5 goal_label">Comment for mentee:</label>
              <div class="col-12 col-sm-8 col-md-8 col-lg-7 col-xl-7">
                <textarea 
                  name="Comment for mentee"
                  class="form-control"
                  v-model="comment"
                  placeholder="How did the mentee do on this task?"
                  maxLength="180"
                  @blur="characterCount"
                  @input="characterCount">
                </textarea>
                <span class="hint">{{ this.remainCharacters + ' Characters' }}</span>
              </div>
            </div>
            <div v-if="showWait == false" class="text-center">
                <button type="submit" class="btn btn-sm btn-blue goal_btn text-center" v-on:click="onSubmit()">Add Rep</button>
            </div>

            <div v-if="showWait == true" class="text-center">
                <button type="submit" class="btn btn-sm btn-blue goal_btn text-center">Please wait...</button>
            </div>
          
          <hr class="custom_hr">
          <a href="javascript:void(0);" @click="showRepsHistory" class="reps_history">
              Repetition History <i :class="toggleFontIcon" style="font-size: 20px;"></i>
          </a>
          <RepetitionHistory 
            :menteeId="menteeId"
            :tasklistId="tasklistId"
            :taskId="this.taskId"
            :subtaskId="subtaskId"
            ref="reps_history"
            parent_form="add_reps"
          >
          </RepetitionHistory>
        </div>

        <!-- EDIT REPS START -->
        <EditRepetition
          ref="edit_repetition_form"
          :menteeId="menteeId"
          :tasklistId="tasklistId"
          :taskId="this.taskId"
          :subTaskId="subTaskId"
          :editReps="editReps"
          :score_options="items_options"
          :vmessage="vmessage"
        >
        </EditRepetition>
        <!-- EDIT REPS END -->

        <!-- DELETE REPS START -->
        <DeleteRepetition
          ref="delete_repetition_form"
          :deleteRepItem="deleteRepItem"
          :deleteReps="deleteReps"
        >
        </DeleteRepetition>
        <!-- DELETE REPS END -->

      </div>
     </div>
</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import RepetitionHistory from './repetition_history';
import EditRepetition from './edit_repetition.vue';
import DeleteRepetition from './delete_repetition.vue';

const today = new Date();
today.setHours(0, 0, 0, 0);

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});

Vue.filter('formatHourMin', function(value) {
  if (value) {
      let hour = Math.floor(value/60);
      let min = (value%60);
      let timeTask; 

      if (hour > 0) {
        timeTask = hour + ' Hour(s) ' + min + ' Minutes' ;
      }
      else {
        timeTask = min + ' Minutes' ;  
      }
    return timeTask;
  }
});


export default {
  props: [
    'isModalVisible',
    'menteeId',
    'tasklistId',
    'subTaskId',
    'headingId',
    'goalSNo',
    'searchText',
    'originFrom'
    ],
  data() {
    return {
        strippedContent: '',
        submit_form_errors: '',
        items_options:[],
        timePickerStyle: {},
        remainCharacters: 180,
        comment: '',
        display_time: '',
        timeOnTask: '',
        score: '',
        taskId: '',
        task_name: '',
        toggleFontIcon: 'fa fa-angle-up',
        vmessage: '',
        displayReps: true,
        editReps: false,
        deleteReps: false,
        deleteRepItem: {},
        modalTitle: 'Add Repetition',
        showWait: false,
        helpRating: '',
    }
  },
  methods: {
    navigate() {
      var navigatePath = this.$router.currentRoute.path;
      if (this.subTaskId) {
        navigatePath += '?e1=' + this.subTaskId;
      }
      if (this.headingId) {
        navigatePath += '&e2=' + this.headingId;
      }
      if ((this.goalSNo) || (this.goalSNo == 0)) {
        navigatePath += '&e5=' + this.goalSNo;
      }
      if (this.searchText) {
        navigatePath += '&e6=' + this.searchText;
      }
      if (this.tasklistId) {
        if (!this.subTaskId && !this.headingId) {
          navigatePath += '?e4=' + this.tasklistId;
        } else {
          navigatePath += '&e4=' + this.tasklistId;
        }
      }
      if (this.originFrom) {
        navigatePath += '&e7=' + this.originFrom;
      }

      this.$router.push(navigatePath)
      this.$router.go();
    },
    closeModal() {
      this.comment = '';
      this.score = '';
      this.display_time = '';
      this.vmessage = 'hide_vmessage';
      if (this.displayReps) {
        this.$refs.reps_history.hideRepsHistory();
      } else {
        this.showDisplayReps();
      }
      this.$validator.errors.clear();
      this.$emit('close');
    },
    characterCount: function() {
      if(this.comment.length > 0){
          this.remainCharacters = 180 - this.comment.length;
      }
    },
    timepickerClick: function(eventData) {
        var ele = document.getElementsByClassName("mx-time-columns")[0].childNodes;
        var ele1 = ele[0].innerHTML;
        var ele2 = ele[1].innerHTML;
        var ishour = document.getElementsByClassName('hour_label');
        if(ishour.length == 0) {
          ele[0].innerHTML = '<div class="hour_label">Hours</div>' + ele1;
        }
        var isminutes = document.getElementsByClassName('minute_label');
        if(isminutes.length == 0) {
          ele[1].innerHTML = '<div class="minute_label">Minutes</div>' + ele2;
        }
      var d = new Date(eventData);
      var hours = d.getHours();
      var mins = d.getMinutes();
      let hourMins = hours*60;
      this.timeOnTask = hourMins + mins;
      if (hours >= 0 && mins > 0) {
       this.$refs.timepicker.closePopup();
      }
    },
    getScoreLists(item, msg) {
      //console.log(item);
      this.taskId = item.id ? item.id : '';
      this.helpRating = item.otherTaskRating ? item.otherTaskRating : '';
      this.task_name = item.description ? item.description : '';    
      this.items_options = [];
      this.vmessage = msg;
      axios.get('/score-lists', {
      })
      .then(response =>  {
        this.score_selected = '';
        var scores = response.data;

        for(var i=0; i<scores.length; i++) {
          this.items_options.push({
            value: scores[i].value,
            display: scores[i].text,
          });
        }
      })
      .catch(() => {
      });

      this.timePickerStyle['left'] = '50%';
      this.timePickerStyle['top'] = '70%';
      this.timePickerStyle['transform'] = 'translate(-30%, -60%)';
      this.timePickerStyle['z-index'] = '9999';
      setTimeout(()=>{
      this.$refs.reps_history.fetchRepsHistory();
      }, 300);
    },
    inputHandler(eventData) {
      var d = new Date(eventData);
      var hours = d.getHours();
      var mins = d.getMinutes();
      let hourMins = hours*60;
      this.timeOnTask = hourMins + mins;
      if (hours >= 0 && mins > 0) {
       this.$refs.timepicker.closePopup();
      }
    },
    showRepsHistory() {
      this.$refs.reps_history.fetchRepsHistory();
    },
    onSubmit() {
      this.vmessage = "show_vmessage";
      this.$validator.validateAll().then((result) => {
          if(!result){
              return;
          }
          this.saveRepetition();
      }).catch(() => {
          // catches the error;
      });
    },
    saveRepetition() {
      
      if (this.timeOnTask > 0) {
        this.showWait = true;
        axios('/desktop/mentee/ratingrepetition/insert',
        {
          method: 'POST',
          data: {
            comment: this.comment,
            time_on_task: this.timeOnTask,
            mentee_id: this.menteeId,
            task_id: this.taskId,
            tasklist_id: this.tasklistId,
            subtask: this.subTaskId,
            score: this.score,
            account_id: this.$store.state.user_accountid,
          },
        })
        .then(() => {
          //this.showWait = false;
          this.flash({ message: 'Repetition added successfully', variant: 'success' });
          this.closeModal();
          this.navigate();
        })
        .catch((error) => {
          this.showWait = false;
          // console.log(error)
          this.submit_form_errors = error.response.data.message;
        });
      } else {
        alert("Please select time spent on task");
      }
    },
    getTaskName() {
      var task_name = '';
      if (this.displayReps) {
        task_name = this.task_name;    
      } else {
        task_name = '1. ' + this.task_name;
      }

      return task_name;
    },
    showDisplayReps() {
      this.editReps = false;
      this.deleteReps =  false;
      this.displayReps = true;
      this.modalTitle = 'Repetition Recording';
    },
    showEditRep(item) {
      this.$refs.edit_repetition_form.getRepItem(item);
    },    
  },
  components: {
    DatePicker,
    RepetitionHistory,
    EditRepetition,
    DeleteRepetition
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: 500px;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;  
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;  
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  font-weight: 900;
  font-size: 14px;
}
.goal-content {
  font-size: 12px;
  padding: 0;
  margin: 0;
}
.goal-content p { margin-bottom: 0rem; }
.goal-form {
  margin: 20px 0px;
  font-size: 13px;
}
.goal_input {
  border: 2px solid #ddd !important;
  border-radius: 5px !important;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.goal_label {
  font-weight: 900;
  padding: 0.375rem 0.75rem;
}
.goal_label span {
  font-weight: normal;
}
.goal_btn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 150px;
}
.task_name {
  font-size: 14px;
}
.custom_hr {
  border-bottom: 1px solid #00acee;
  margin: 10px 0px;
  width: 100%;
}
.mx-datepicker { width: 100%; }
.form-control { font-size: 14px; }
.hint { float: right; }
.reps_history, .reps_history:active, .reps_history:focus {
  font-size: 14px;
  font-weight: 900;
  color: #002F42 !important;
  text-decoration: none !important;
}
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.fa-chevron-left {
  color: #00ACEE;
  font-size: 20px;
  font-weight: 900;
  margin-right: 10px;
}
.otherTaskRating {
  border-top: 1px solid #00ACEE;
  margin-top: 10px;
  padding-top: 10px;
  font-size: 12px;
  margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/add_repetition.vue